module.exports = __webpack_public_path__ + "static/media/icon_request_payment.aa77d21f.png";